import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classes from './navBar.module.scss';
import LoadingProgress from '../_common/LoadingProgress/LoadingProgress';
import accountHelpers from '../../utils/accountHelpers';
import useWindowSize from '../../utils/hooks/useMobile';
import { ReactComponent as DotesIcon } from '../../assets/icons/dotes.svg';
import { ReactComponent as DashboardIcon } from '../../assets/icons/dashboard.svg';
import { ReactComponent as ReportIcon } from '../../assets/icons/report.svg';
import { ReactComponent as NoteIcon } from '../../assets/icons/note.svg';
import { ReactComponent as PipelineCRMIcon } from '../../assets/icons/schedule.svg';

const NavBar = () => {
  const { menu } = useSelector((store) => store.menu);
  const { isMobile } = useWindowSize(900);
  const [openMoreMenu, setOpenMoreMenu] = useState(false);

  let currentUserMenu = menu;
  const { account } = useSelector((store) => store.auth);

  const userRole = account.role;
  if (userRole === 'Rep') {
    currentUserMenu = menu.filter((d) => (d.name !== 'Products' && d.name !== 'Refills'
      && d.name !== 'Reports'));
  } else if (userRole === 'Pharmacy') {
    currentUserMenu = menu.filter((d) => {
      if (accountHelpers.isLoggedInAsPriorityPharmacies()) {
        return (d.name !== 'Dashboard');
      }

      if (accountHelpers.isLoggedInAsFredyOrellana()) {
        return (d.name !== 'Dashboard' && d.name !== 'Reports' && d.name !== 'My Team');
      }

      if (account.Manufacturer.length) {
        return (d.name !== 'Dashboard' && d.name !== 'Reports' && d.name !== 'Health Plans');
      }

      return (d.name !== 'Dashboard' && d.name !== 'Reports' && d.name !== 'Health Plans' && d.name !== 'My Team');
    });
  } else if (userRole === 'Physician') {
    currentUserMenu = [
      ...menu.filter((d) => d.name === 'Scripts' || d.name === 'Patients'),
      {
        path: sessionStorage.getItem('Auto Refill Data') || '/dashboard/autofill-data',
        icon: <DashboardIcon />,
        name: 'Auto Refill Data',
      },
    ];
  } else if (userRole === 'Health') {
    currentUserMenu = [
      ...menu.filter((d) => d.name === 'Patients'
          || d.name === 'Dashboard' || d.name === 'Physicians',
        // || d.name === 'Possible persons'
      ),
      {
        path: sessionStorage.getItem('Pipeline') || '/health/pipeline',
        icon: <NoteIcon />,
        name: 'Pipeline',
      },
      {
        path: sessionStorage.getItem('Pipeline Reports') || '/health/pipeline-reports',
        icon: <ReportIcon />,
        name: 'Pipeline Reports',
      },
      {
        path: sessionStorage.getItem('Pipeline CRM') || '/health/pipeline-crm',
        icon: <PipelineCRMIcon />,
        name: 'Pipeline CRM',
      },
    ];
  } else if (userRole === 'Manufacturer Users') {
    currentUserMenu = menu.filter((d) => d.name === 'Dashboard' || d.name === 'Scripts' || d.name === 'Reports'
      || d.name === 'My Team');
  } else if (userRole === 'Patient') {
    currentUserMenu = [];
  }

  const fixingHeader = () => {
    const windowTop = Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop);

    if (windowTop >= 102) {
      document.body.classList.add('navbar_border');
    } else {
      document.body.classList.remove('navbar_border');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', fixingHeader);
    window.addEventListener('click', closeMenu, true);

    return () => {
      window.removeEventListener('click', closeMenu, true);

      window.removeEventListener('scroll', fixingHeader);
    };
  }, []);

  const closeMenu = (e) => {
    if (!e.target.closest('[id="more_menu_item"]')) {
      setOpenMoreMenu(false);
    }
  };

  const showMoreMenu = isMobile && currentUserMenu.length > 10;

  const renderMenu = showMoreMenu ? currentUserMenu.slice(0, 8) : currentUserMenu;

  const moreMenuItems = currentUserMenu.slice(8, currentUserMenu.length);

  return (
    <>
      <div className={classes.nav_bg} />

      <nav id="nav_bar" className={classes.nav_wrapper}>
        {renderMenu.map(({ name, path, icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => (isActive ? `${classes.menu_item} ${classes.active}` : classes.menu_item)}
          >
            {icon}

            <div>{name}</div>
          </NavLink>
        ))}

        {showMoreMenu && (
        <div
          className={openMoreMenu ? `${classes.menu_item} ${classes.active_more}` : classes.menu_item}
          onClick={() => setOpenMoreMenu((prev) => !prev)}
          role="button"
          tabIndex="0"
          id="more_menu_item"
        >
          <DotesIcon className={classes.dotes_icon} />

          <div>More</div>

          {openMoreMenu && (
          <div className={classes.more_menu_item}>
            {moreMenuItems.map(({ name, path, icon }) => (
              <NavLink
                key={path}
                to={path}
                className={({ isActive }) => (isActive
                  ? `${classes.menu_item} ${classes.active}`
                  : classes.menu_item)}
              >
                {icon}

                <div>{name}</div>
              </NavLink>

            ))}
          </div>
          )}
        </div>
        )}
      </nav>

      <LoadingProgress />
    </>
  );
};

export default NavBar;
